import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function DashboardContractuels() {
    const [contractuels, setContractuels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [editing, setEditing] = useState(null);

    const [showPdfDialog, setShowPdfDialog] = useState(false);

    // Signature gauche
    const [signatureGauche, setSignatureGauche] = useState({ service: '', grade: '', nom: '' });
    const [cachetGaucheFile, setCachetGaucheFile] = useState(null);
    const [cachetGauchePreview, setCachetGauchePreview] = useState(null);

    // Signature droite
    const [signatureDroite, setSignatureDroite] = useState({ service: '', grade: '', nom: '' });
    const [cachetDroiteFile, setCachetDroiteFile] = useState(null);
    const [cachetDroitePreview, setCachetDroitePreview] = useState(null);

    // Logo unique
    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);

    const [form, setForm] = useState({
        nom: '',
        prenom: '',
        fonction: '',
        date_debut_contrat: '',
        date_fin_contrat: '',
        salaire_mensuel: '',
        telephone: '',
        email: '',
        commentaire: ''
    });

    // Utilisation de la configuration centralisée
    const API_BASE = `${config.apiBase}/rh`;

    const fetchContractuels = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/lister_contractuels.php`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) setContractuels(data.contractuels);
        } catch (error) {
            toast.error('Erreur chargement');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            const url = editing
                ? `${API_BASE}/modifier_contractuel.php`
                : `${API_BASE}/ajouter_contractuel.php`;
            const payload = editing ? { ...form, id_contractuel: editing } : form;
            const res = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (data.success) {
                toast.success(editing ? 'Contractuel modifié' : 'Contractuel ajouté');
                setShowForm(false);
                setEditing(null);
                setForm({
                    nom: '', prenom: '', fonction: '',
                    date_debut_contrat: '', date_fin_contrat: '',
                    salaire_mensuel: '', telephone: '', email: '', commentaire: ''
                });
                fetchContractuels();
            } else toast.error(data.message);
        } catch (error) {
            toast.error('Erreur réseau');
        }
    };

    const handleDelete = async (id, nom) => {
        if (!window.confirm(`Supprimer définitivement ${nom} ?`)) return;
        const token = localStorage.getItem('token');
        try {
            const res = await fetch(`${API_BASE}/supprimer_contractuel.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ id_contractuel: id })
            });
            const data = await res.json();
            if (data.success) {
                toast.success('Contractuel supprimé');
                fetchContractuels();
            } else toast.error(data.message);
        } catch (error) {
            toast.error('Erreur suppression');
        }
    };

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    const generatePDF = () => setShowPdfDialog(true);

    const confirmGeneratePDF = async () => {
        if (!signatureGauche.service || !signatureGauche.grade || !signatureGauche.nom ||
            !signatureDroite.service || !signatureDroite.grade || !signatureDroite.nom) {
            toast.error("Veuillez remplir tous les champs des deux signatures.");
            return;
        }

        let logoBase64 = '';
        if (logoFile) logoBase64 = await fileToBase64(logoFile);
        let cachetGaucheBase64 = '';
        if (cachetGaucheFile) cachetGaucheBase64 = await fileToBase64(cachetGaucheFile);
        let cachetDroiteBase64 = '';
        if (cachetDroiteFile) cachetDroiteBase64 = await fileToBase64(cachetDroiteFile);

        const printContent = `<!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Liste des contractuels CROUS Dosso</title>
            <style>
                @page { size: landscape; margin: 2.5cm; }
                body { font-family: 'Times New Roman', 'Georgia', serif; margin: 0; padding: 0; line-height: 1.4; position: relative; }
                .watermark { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; width: 350px; height: auto; pointer-events: none; }
                .header { text-align: center; margin-bottom: 25px; border-bottom: 2px solid #1e3a8a; padding-bottom: 12px; position: relative; }
                .header-logo { position: absolute; left: 0; top: 0; width: 65px; height: auto; opacity: 1; }
                .republic { font-size: 13px; font-weight: bold; color: #1e3a8a; letter-spacing: 1px; }
                .ministere { font-size: 11px; font-style: italic; }
                .crous { font-size: 14px; font-weight: bold; margin-top: 5px; color: #166534; }
                .title { font-size: 16px; font-weight: bold; margin: 15px 0 10px; text-decoration: underline; color: #1e3a8a; }
                table { width: 100%; border-collapse: collapse; font-size: 10px; margin-top: 15px; }
                th, td { border: 1px solid #333; padding: 6px 4px; text-align: left; vertical-align: top; }
                th { background-color: #dbeafe; font-weight: bold; color: #1e3a8a; }
                .signatures-container { margin-top: 45px; display: flex; justify-content: space-between; position: relative; }
                .signature-box { text-align: center; width: 45%; border-top: 1px dashed #888; padding-top: 20px; position: relative; }
                .signature-line { margin: 5px 0; font-size: 12px; }
                .cachet { position: absolute; right: -20px; bottom: -10px; width: 80px; height: auto; opacity: 0.7; }
                footer { margin-top: 25px; text-align: center; font-size: 8px; color: #777; border-top: 1px solid #ccc; padding-top: 8px; }
            </style>
        </head>
        <body>
            ${logoBase64 ? `<img src="${logoBase64}" class="watermark" alt="Watermark" />` : ''}
            <div class="header">
                ${logoBase64 ? `<img src="${logoBase64}" class="header-logo" alt="Logo CROUS" />` : ''}
                <div class="republic">RÉPUBLIQUE DU NIGER</div>
                <div class="ministere">Ministère de l'Enseignement Supérieur de la Recherche et de l'Innovation Technologique</div>
                <div class="crous">UNIVERSITE DE DOSSO</div>
                <div class="crous">CENTRE RÉGIONAL DES ŒUVRES UNIVERSITAIRES (CROU) DE DOSSO</div>
                <div class="title">LISTE DES CONTRACTUELS</div>
            </div>
            <table style="width:100%; border-collapse:collapse; font-size:10px; margin-top:15px;">
                <thead><tr style="background-color:#dbeafe;">
                    <th>Nom</th><th>Prénom</th><th>Fonction</th><th>Début contrat</th><th>Fin contrat</th>
                    <th>Salaire (F CFA)</th><th>Téléphone</th><th>Email</th>
                <tr></thead>
                <tbody>${contractuels.map(c => `<tr>
                    <td style="border:1px solid #333; padding:6px;">${c.nom || ''}</td>
                    <td style="border:1px solid #333; padding:6px;">${c.prenom || ''}</td>
                    <td style="border:1px solid #333; padding:6px;">${c.fonction || ''}</td>
                    <td style="border:1px solid #333; padding:6px;">${c.date_debut_contrat || ''}</td>
                    <td style="border:1px solid #333; padding:6px;">${c.date_fin_contrat || ''}</td>
                    <td style="border:1px solid #333; padding:6px;">${parseInt(c.salaire_mensuel || 0).toLocaleString()} F</td>
                    <td style="border:1px solid #333; padding:6px;">${c.telephone || ''}</td>
                    <td style="border:1px solid #333; padding:6px;">${c.email || ''}</td>
                </tr>`).join('')}</tbody>
            </table>
            <div class="signatures-container">
                <div class="signature-box">
                    <div class="signature-line">Fait à Dosso, le ${new Date().toLocaleDateString('fr-FR')}</div>
                    <div class="signature-line" style="margin-top:15px;"><strong>${signatureGauche.service}</strong></div>
                    <div class="signature-line">${signatureGauche.grade}</div>
                    <div class="signature-line" style="text-decoration:underline; margin-bottom:10px;">${signatureGauche.nom}</div>
                    ${cachetGaucheBase64 ? `<img src="${cachetGaucheBase64}" class="cachet" alt="Cachet gauche" />` : ''}
                </div>
                <div class="signature-box">
                    <div class="signature-line">Fait à Dosso, le ${new Date().toLocaleDateString('fr-FR')}</div>
                    <div class="signature-line" style="margin-top:15px;"><strong>${signatureDroite.service}</strong></div>
                    <div class="signature-line">${signatureDroite.grade}</div>
                    <div class="signature-line" style="text-decoration:underline; margin-bottom:10px;">${signatureDroite.nom}</div>
                    ${cachetDroiteBase64 ? `<img src="${cachetDroiteBase64}" class="cachet" alt="Cachet droit" />` : ''}
                </div>
            </div>
            <footer>Document généré par le système intégré de gestion du CROUS Dosso</footer>
        </body>
        </html>`;

        const printWindow = window.open('', '_blank');
        if (!printWindow) { toast.error("Veuillez autoriser les popups pour générer le PDF"); return; }
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
        toast.success("PDF généré avec succès");
        setShowPdfDialog(false);
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setLogoPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleCachetGaucheChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCachetGaucheFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setCachetGauchePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleCachetDroiteChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCachetDroiteFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setCachetDroitePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    useEffect(() => { fetchContractuels(); }, []);

    if (loading) return <div className="p-6 text-center">Chargement des contractuels...</div>;

    const columns = [
        { key: 'nom', label: 'Nom' },
        { key: 'prenom', label: 'Prénom' },
        { key: 'fonction', label: 'Fonction' },
        { key: 'date_debut_contrat', label: 'Début contrat' },
        { key: 'date_fin_contrat', label: 'Fin contrat' },
        { key: 'salaire_mensuel', label: 'Salaire (F CFA)' },
        { key: 'telephone', label: 'Téléphone' },
        { key: 'email', label: 'Email' }
    ];

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-blue-800">📄 Gestion des contractuels</h1>
                <div className="space-x-2">
                    <button onClick={generatePDF} className="bg-green-700 text-white px-4 py-2 rounded shadow hover:bg-green-800">📄 Exporter en PDF</button>
                    <button onClick={() => { setEditing(null); setForm({
                        nom: '', prenom: '', fonction: '',
                        date_debut_contrat: '', date_fin_contrat: '',
                        salaire_mensuel: '', telephone: '', email: '', commentaire: ''
                    }); setShowForm(true); }} className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700">+ Ajouter un contractuel</button>
                </div>
            </div>

            <div className="overflow-x-auto bg-white rounded-xl shadow">
                <table className="min-w-full text-sm">
                    <thead className="bg-gray-100">
                        <tr>{columns.map(col => <th key={col.key} className="p-2 whitespace-nowrap">{col.label}</th>)}<th className="p-2">Actions</th></tr>
                    </thead>
                    <tbody>
                        {contractuels.map(c => (<tr key={c.id_contractuel} className="border-b hover:bg-gray-50">
                            {columns.map(col => (<td key={col.key} className="p-2 whitespace-nowrap">{col.key === 'salaire_mensuel' ? `${parseInt(c[col.key] || 0).toLocaleString()} F` : c[col.key] || '-'}</td>))}
                            <td className="p-2 whitespace-nowrap">
                                <button onClick={() => { setEditing(c.id_contractuel); setForm(c); setShowForm(true); }} className="text-blue-600 mr-2 hover:underline">✏️</button>
                                <button onClick={() => handleDelete(c.id_contractuel, c.nom)} className="text-red-500 hover:underline">🗑️</button>
                            </td>
                        </tr>))}
                    </tbody>
                </table>
            </div>

            {showForm && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-6">
                        <h2 className="text-xl font-bold mb-4">{editing ? '✏️ Modifier contractuel' : '➕ Nouveau contractuel'}</h2>
                        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-3">
                            <input name="nom" placeholder="Nom *" value={form.nom || ''} onChange={e => setForm({ ...form, nom: e.target.value })} className="border p-2 rounded" required />
                            <input name="prenom" placeholder="Prénom *" value={form.prenom || ''} onChange={e => setForm({ ...form, prenom: e.target.value })} className="border p-2 rounded" required />
                            <input name="fonction" placeholder="Fonction *" value={form.fonction || ''} onChange={e => setForm({ ...form, fonction: e.target.value })} className="border p-2 rounded" required />
                            <input name="date_debut_contrat" type="date" value={form.date_debut_contrat || ''} onChange={e => setForm({ ...form, date_debut_contrat: e.target.value })} className="border p-2 rounded" required />
                            <input name="date_fin_contrat" type="date" value={form.date_fin_contrat || ''} onChange={e => setForm({ ...form, date_fin_contrat: e.target.value })} className="border p-2 rounded" required />
                            <input name="salaire_mensuel" type="number" placeholder="Salaire mensuel *" value={form.salaire_mensuel || ''} onChange={e => setForm({ ...form, salaire_mensuel: e.target.value })} className="border p-2 rounded" required />
                            <input name="telephone" placeholder="Téléphone" value={form.telephone || ''} onChange={e => setForm({ ...form, telephone: e.target.value })} className="border p-2 rounded" />
                            <input name="email" placeholder="Email" value={form.email || ''} onChange={e => setForm({ ...form, email: e.target.value })} className="border p-2 rounded" />
                            <textarea name="commentaire" placeholder="Commentaire" rows="2" value={form.commentaire || ''} onChange={e => setForm({ ...form, commentaire: e.target.value })} className="col-span-2 border p-2 rounded" />
                            <div className="col-span-2 flex justify-end gap-2 mt-2">
                                <button type="button" onClick={() => setShowForm(false)} className="bg-gray-400 text-white px-4 py-2 rounded">Annuler</button>
                                <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">{editing ? 'Modifier' : 'Ajouter'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showPdfDialog && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl w-full max-w-md p-6" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                        <h2 className="text-xl font-bold mb-4 sticky top-0 bg-white pb-2">Informations de signature</h2>
                        <div className="mb-4"><label className="block text-sm font-medium mb-1">Logo entête (filigrane + entête)</label><input type="file" accept="image/*" onChange={handleLogoChange} className="w-full border p-2 rounded" />{logoPreview && <img src={logoPreview} alt="Logo" className="mt-2 h-16 object-contain" />}</div>
                        <hr className="my-4" />
                        <div className="border-l-4 border-blue-500 pl-4 mb-6"><h3 className="font-bold text-blue-700 mb-3">🖊️ Signature (gauche)</h3><input type="text" placeholder="Service / Titre" className="w-full border p-2 rounded mb-2" value={signatureGauche.service} onChange={e => setSignatureGauche({ ...signatureGauche, service: e.target.value })} /><input type="text" placeholder="Grade" className="w-full border p-2 rounded mb-2" value={signatureGauche.grade} onChange={e => setSignatureGauche({ ...signatureGauche, grade: e.target.value })} /><input type="text" placeholder="Nom complet" className="w-full border p-2 rounded mb-2" value={signatureGauche.nom} onChange={e => setSignatureGauche({ ...signatureGauche, nom: e.target.value })} /><div><label className="block text-sm font-medium mb-1">Cachet (optionnel)</label><input type="file" accept="image/*" onChange={handleCachetGaucheChange} className="w-full border p-2 rounded" />{cachetGauchePreview && <img src={cachetGauchePreview} alt="Cachet gauche" className="mt-2 h-16 object-contain" />}</div></div>
                        <div className="border-l-4 border-green-500 pl-4"><h3 className="font-bold text-green-700 mb-3">🖊️ Signature (droite)</h3><input type="text" placeholder="Service / Titre" className="w-full border p-2 rounded mb-2" value={signatureDroite.service} onChange={e => setSignatureDroite({ ...signatureDroite, service: e.target.value })} /><input type="text" placeholder="Grade" className="w-full border p-2 rounded mb-2" value={signatureDroite.grade} onChange={e => setSignatureDroite({ ...signatureDroite, grade: e.target.value })} /><input type="text" placeholder="Nom complet" className="w-full border p-2 rounded mb-2" value={signatureDroite.nom} onChange={e => setSignatureDroite({ ...signatureDroite, nom: e.target.value })} /><div><label className="block text-sm font-medium mb-1">Cachet (optionnel)</label><input type="file" accept="image/*" onChange={handleCachetDroiteChange} className="w-full border p-2 rounded" />{cachetDroitePreview && <img src={cachetDroitePreview} alt="Cachet droit" className="mt-2 h-16 object-contain" />}</div></div>
                        <div className="flex justify-end gap-2 mt-6 sticky bottom-0 bg-white pt-2"><button onClick={() => setShowPdfDialog(false)} className="bg-gray-400 text-white px-4 py-2 rounded">Annuler</button><button onClick={confirmGeneratePDF} className="bg-green-600 text-white px-4 py-2 rounded">Générer le PDF</button></div>
                    </div>
                </div>
            )}
        </div>
    );
}